import { useTranslation } from "react-i18next";
import { useUIStore } from "../store/ui";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Spinner } from "./ui/Spinner";

/**
 * Blocking progress dialog for bulk export. Mounted once at the app root next
 * to `PaywallDialog`. Deliberately non-dismissable: the ZIP is built in this
 * tab, so navigating away mid-run throws the work away. Swift mirrors it with
 * `BulkExportProgressSheet`.
 */
export function ExportProgressDialog() {
  const { t } = useTranslation();
  const progress = useUIStore((s) => s.exportProgress);

  return (
    <Dialog open={progress !== null}>
      <DialogContent
        className="w-[340px] p-7"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="flex flex-col items-center gap-4 text-center">
          <Spinner size="lg" />
          <DialogTitle className="text-[15px] text-ink">
            {t("bulkActions.exportingTitle")}
          </DialogTitle>
          <p className="text-[13px] leading-relaxed text-ink-secondary">
            {t("bulkActions.exportingBody")}
          </p>
          <p className="text-[13px] font-medium text-muted tabular-nums">
            {t("bulkActions.exportingProgress", {
              done: progress?.done ?? 0,
              total: progress?.total ?? 0,
            })}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
